import { useSeo } from "@/lib/seo";

const DOCS = {
  privacy: ["Privacy Policy", [
    ["What we collect", "When you send an enquiry, application or message we collect the details you enter — name, company, contact details, product requirements and any files you attach."],
    ["How we use it", "Only to respond to your enquiry, prepare quotations, process job applications and send the acknowledgement emails you request. We do not sell your data."],
    ["Cookies & analytics", "We use essential storage to remember your enquiry list and unit preference, and anonymous analytics (Google Analytics 4) if you accept cookies."],
    ["Retention & contact", "Records are kept for as long as needed for business and legal purposes. To access or delete your data, write to info@tijiya.in."],
    ["Note", "[This policy is a placeholder and should be reviewed by Tijiya's legal adviser.]"],
  ]],
  terms: ["Terms of Use", [
    ["Information only", "Product information, specifications and calculator results on this site are indicative. Binding terms are set out in our written quotation and order confirmation."],
    ["No online sales", "This website does not sell products or accept payments. All orders are agreed directly with Tijiya Exports Private Limited."],
    ["Intellectual property", "Content, images and drawings on this site belong to Tijiya Exports Private Limited unless stated otherwise."],
    ["Governing law", "These terms are governed by the laws of India, with courts at Kolkata having jurisdiction."],
    ["Note", "[These terms are a placeholder and should be reviewed by Tijiya's legal adviser.]"],
  ]],
};

export default function Legal({ doc }) {
  const [title, sections] = DOCS[doc];
  useSeo(title);
  return (
    <article data-testid={`legal-${doc}`} className="wrap py-16 max-w-3xl">
      <p className="eyebrow">Legal</p>
      <h1 className="text-4xl sm:text-5xl mt-3">{title}</h1>
      <div className="mt-10 space-y-8">{sections.map(([h, t]) => <section key={h}><h2 className="text-2xl">{h}</h2><p className="mt-2 text-[var(--graphite)]">{t}</p></section>)}</div>
    </article>
  );
}
